import type { ReactNode } from 'react'

import { ThemeToggle } from '@aeris/ui'

import logoHorizontal from '../assets/aeris-logo-horizontal.png'

/**
 * A moldura das telas fora do shell — F132.
 *
 * Entrar e Trocar senha eram a mesma moldura copiada: fundo azul-marinho,
 * logotipo, cartão e rodapé. E as duas pintavam com a PALETA
 * (`--aeris-navy-900`, `--aeris-slate-400`) em vez do token de função, então o
 * fundo não acompanhava o tema. Aqui o fundo é o da barra lateral
 * (`--sidebar-bg`), que já é o azul da marca nos dois temas.
 */
export const AuthCard = ({
  children,
  footer,
}: {
  children: ReactNode
  /** Abaixo do cartão, antes da assinatura: "Voltar ao Aeris", por exemplo. */
  footer?: ReactNode
}): ReactNode => (
  <div className="relative flex min-h-[100dvh] items-center justify-center bg-(--sidebar-bg) px-4 py-8">
    <div className="absolute right-4 top-4">
      <ThemeToggle />
    </div>

    <main className="w-full max-w-sm">
      <div className="mb-8 flex flex-col items-center gap-3">
        {/* Official asset, used as provided (docs/brand/BRAND.md). */}
        <img
          src={logoHorizontal}
          alt="Aeris One — Sistema de Gestão"
          className="h-11 w-auto brightness-0 invert"
        />
      </div>

      <div className="rounded-(--radius-lg) border border-(--border-default) bg-(--surface) p-6 shadow-(--shadow-lg)">
        {children}
      </div>

      {footer === undefined ? null : (
        <div className="mt-4 flex justify-center">{footer}</div>
      )}

      <p className="mt-6 text-center text-(length:--text-xs) text-(--sidebar-text) opacity-70">
        Aeris One · Sistema de Gestão
      </p>
    </main>
  </div>
)
